import React from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {
    AutocompleteArrayInput,
    BooleanInput,
    LongTextInput,
    ReferenceArrayInput,
    ReferenceInput,
    Title
} from 'react-admin';
import {NotifyForm, schoolYears, showErrorNotify, TreeCheckboxInput} from '../../components';
import env from '../../env';
import {downloadFilePost} from "../../components/FileDownload";
import axiosInstance from "../../api/axios";
import TreeCheckBoxCustomInput from "../../components/TreeCheckBoxCustomInput";
import utils from "../../utils/utils";

class BillItemNotifyByBatch extends React.Component {
    state = {
        loading: false,
        displayDueDate: true,
        customers: [],
        params: {
            batchIds: [],
            customerIds: [],
            note: '',
        }
    };

    componentDidMount(prevProps, prevState, snapshot) {
        axiosInstance
            .get('/api/customersByUnits?studentOnly=true')
            .then(rs => this.setState({customers: rs.data.content || []}))
    }
    getReportUrl = (fullDay, allStudent) => {
        this.setState({loading: true})
        if (!this.state.params.note) {
            this.state.params.note = '';
        }
        const data = {
            fullDayOnly: fullDay,
            allStudent: allStudent,
            displayDueDate: this.state.params.displayDueDate,
            note: this.state.params.note,
            batchIds: this.state.params.batchIds,
            customerIds: this.state.params.customerIds
        }
        downloadFilePost(`${env.baseURL}/reports/generateBillItemNotifyByBatchIds`, 'thong_bao_hoc_phi.xlsx', data)
            .then(() => {
                this.setState({loading: false})
            })
            .catch(() => {
                this.setState({loading: false})
            })
    }
    notifyAllStudents = () => {
        if (this.state.params.customerIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách học sinh")
            return;
        }
        if (!this.state.params.batchIds || this.state.params.batchIds.length === 0) {
            showErrorNotify("Vui lòng chọn kế hoạch")
            return;
        }
        this.getReportUrl(false, true)
    };

    fullDayOnly = () => {
        if (!this.state.params.customerIds || this.state.params.customerIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách học sinh")
            return;
        }
        if (!this.state.params.batchIds || this.state.params.batchIds.length === 0) {
            showErrorNotify("Vui lòng chọn kế hoạch")
            return;
        }
        this.getReportUrl(true, false)
    };

    notFullDayOnly = () => {
        if (!this.state.params.customerIds || this.state.params.customerIds.length === 0) {
            showErrorNotify("Vui lòng chọn danh sách học sinh")
            return;
        }
        if (!this.state.params.batchIds || this.state.params.batchIds.length === 0) {
            showErrorNotify("Vui lòng chọn kế hoạch")
            return;
        }
        this.getReportUrl(false, false)
    };

    validate = (values) => {
        const errors = {};

        // Copy input values to params
        this.setState({params: {...this.state.params, ...values}})

        return errors;
    };

    render() {
        return (
            <Card>
                <Title title="resources.billItemNotifyByBatch.name"/>
                <CardContent>
                    <NotifyForm validate={this.validate}
                                allClazzes={this.notifyAllStudents}
                                fullDayClazzes={this.fullDayOnly}
                                notFullDayClazzes={this.notFullDayOnly}
                                params={this.state}
                                isLoading={this.state.loading}
                    >
                        <Grid container spacing={8}>
                            <ReferenceArrayInput
                                source="batchIds"
                                label="resources.billBatches.name"
                                reference="billBatches"  {...this.props}
                            >
                                <AutocompleteArrayInput optionText={'displayDescription'}/>
                            </ReferenceArrayInput>
                        </Grid>
                        <Grid container spacing={8}>
                            <Grid item xs={12} sm={6}>
                                <BooleanInput label="resources.billItemNotifyByBatch.displayDueDate"
                                              source="displayDueDate" {...this.props}  />
                            </Grid>

                        </Grid>
                        <Grid container spacing={8}>
                            <Grid item xs={12} sm={6}>
                                <LongTextInput label="resources.billItemNotifyByBatch.note"
                                               rows={5}
                                               style={{maxWidth: '90%'}}
                                               multiline
                                               source="note" {...this.props} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <label><b>Danh sách học sinh</b></label>
                                <div style={{width: 500, maxHeight: '300px', overflow: 'auto', marginTop: 10}}>
                                    <TreeCheckBoxCustomInput data={this.state.customers} expandTopLevel={true}
                                                             onChange={(value) => this.setState({
                                                                 params: {
                                                                     ...this.state.params,
                                                                     customerIds: utils.extractCustomerIdsV2(value)
                                                                 }
                                                             })}/>
                                </div>
                            </Grid>
                        </Grid>
                    </NotifyForm>

                </CardContent>
            </Card>
        )
    }
}

export default BillItemNotifyByBatch

